import * as THREE from 'three';

// YOUR BODY IN A ROOM, when the camera is behind it (2026-11-01, Khari: "3rd
// person POV does not work in rooms. let's try to enable that").
//
// A first-person room has always treated the CAMERA as you: InteriorWalk moves
// it, FloorClamp stands it on the floor, SolidClamp pushes it out of furniture,
// doors and counters measure from it. Third person splits the two, the way the
// street does (WalkControls' `pvec`): this point is the body — its EYE point,
// floor + eye height, so every clamp keeps working on it unchanged — and the
// camera follows it (PlanetScene RoomChase).
//
// `on` is true only while a room is in third person. Off, everything reads the
// camera exactly as before. A live object, not store state: it changes every
// frame and nothing should re-render for it.
export const roomBody = { on: false, v: new THREE.Vector3() };

/** The point that walks in a room: the body in third person, else the camera. */
export const roomWalker = (camera) => (roomBody.on ? roomBody.v : camera.position);
